import React from 'react';

const categoryStyles = {
    BB_STATUS: { bg: 'bg-purple-50', border: 'border-purple-400', badge: 'bg-purple-100 text-purple-800', label: 'Buy Box' },
    MP_BATTLE: { bg: 'bg-blue-50', border: 'border-blue-400', badge: 'bg-blue-100 text-blue-800', label: 'MP Pros' },
    EXCESS: { bg: 'bg-red-50', border: 'border-red-400', badge: 'bg-red-100 text-red-800', label: 'Excess' },
    RETURNS: { bg: 'bg-yellow-50', border: 'border-yellow-400', badge: 'bg-yellow-100 text-yellow-800', label: 'Returns' },
    RESTOCK: { bg: 'bg-green-50', border: 'border-green-400', badge: 'bg-green-100 text-green-800', label: 'Restock' },
};

export default function TopPriorities({ data }) {
    if (!data || data.length === 0) return null;

    return (
        <div className="bg-white shadow rounded-lg p-6 mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Top 5 Things to Address Today</h2>
            <div className="space-y-3">
                {data.map((item) => {
                    const style = categoryStyles[item.category] || categoryStyles.EXCESS;
                    return (
                        <div
                            key={item.rank}
                            className={`flex items-start gap-4 p-4 rounded-lg border-l-4 ${style.bg} ${style.border}`}
                        >
                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center text-sm font-bold">
                                {item.rank}
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 mb-1">
                                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${style.badge}`}>
                                        {style.label}
                                    </span>
                                    <span className="text-sm font-medium text-gray-900 truncate" title={item.productName}>
                                        {item.productName}
                                    </span>
                                    <span className="text-xs text-gray-400">{item.asin}</span>
                                </div>
                                <p className="text-sm text-gray-700">{item.issue}</p>
                                <p className="text-sm text-gray-500 mt-1">
                                    <span className="font-medium">Action:</span> {item.action}
                                </p>
                            </div>
                            {item.estimatedImpact != null && Number(item.estimatedImpact) > 0 && (
                                <div className="flex-shrink-0 text-right">
                                    <p className="text-xs text-gray-400">Est. Impact</p>
                                    <p className="text-sm font-semibold text-gray-900">${Number(item.estimatedImpact).toFixed(0)}</p>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
